<template>

    <div>
        <Loading/>
        <MenuInternoCadastros/>
        <span><strong>- CONVÊNIOS <i class="fas fa-chevron-right"></i> LISTAGEM
      <span v-if="paginaTop != ''"><i class="fas fa-chevron-right"></i> {{paginaTop}}</span></strong></span>

        <div v-if="listagem == 'listagem'">
            <div class="text-right mb-2">
                <button class="btn btn-sm btn-success" @click="viewAdicionar">Adicionar Convênio</button>
            </div>
            <table id="tabela" class="table table-striped table-responsive-sm">
                <thead>
                <tr>
                    <th>Id</th>
                    <th class="text-center">Número</th>
                    <th class="text-center">Objeto</th>
                    <th class="text-center">Fonte de Recurso</th>
                    <th class="text-center">Ações</th>
                </tr>
                </thead>
            </table>
            <!-- <div style="height: 700px;">
              <div id="grid-convenios" style="width:100%; height:100%; background-color:white;"></div>
            </div>   -->
        </div>

        <div v-else-if="listagem == 'cadastro'">
            <TipoConveniosCadastro/>
        </div>
        <div v-else-if="listagem == 'editar'">
            <TipoConveniosEditar :id='id'/>
        </div>

    </div>
</template>

<script>

    import MenuInternoCadastros from '../menu-interno/MenuInternoCadastros.vue'
    import TipoConveniosCadastro from '../convenios/TipoConveniosCadastro.vue'
    import TipoConveniosEditar from '../convenios/TipoConveniosEditar.vue'
    import Loading from '../login/Loading'

    var gridConv;

    export default {
        name: 'ConveniosListagem',
        components: {
            Loading,
            MenuInternoCadastros,
            TipoConveniosCadastro,
            TipoConveniosEditar
        },
        data() {
            return {
                // isModalVisible: false,
                listagem: 'listagem',
                paginaTop: '',
                data: '',
                id: ''
            }
        },
        mounted: function () {
            let thiss = this;
            let swall = this.$swal;

            let tabela = $('#tabela').DataTable({
                "oLanguage": {
                    "sSearch": "Pesquisar:",
                    "sEmptyTable": "Nenhum dado para exibição",
                    "sZeroRecords": "Nenhum dado encontrado",
                    "oPaginate": {
                        "sNext": "Próximo",
                        "sPrevious": "Anterior",
                    },
                    "sLengthMenu": "Mostrar _MENU_ dados",
                    "sInfoFiltered": " - (filtrado de _MAX_ dados)",
                    "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ dados",
                },
                "ajax": {
                    "url": axios.defaults.baseURL+"/api/sist-obras/convenios",
                    dataSrc: '',
                    headers: {
                        'Authorization': `Bearer ${Store.getters.pegaAccessToken}`
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        API.geraNovoTokenDatatable(jqXHR, tabela);
                    }
                },
                "columns": [
                    {"data": "c05_id", visible: false},
                    {"data": "c05_num"},
                    {"data": "c05_objeto"},
                    {"data": "c05_fonte_rec"},
                    {
                        targets: [4],
                        width: '10%',
                        orderable: false,
                        mData: data => criarBotoes(data.c05_id)
                    }
                ],
                'fnDrawCallback': function () {

                    $('.editar').on('click', function () {
                        var dados = $(this).data('id');
                        thiss.id = dados;
                        thiss.listagem = 'editar'
                        thiss.paginaTop = 'EDITAR'
                        $('#tabela').parents('div.dataTables_wrapper').first().hide();
                    })
                    $('.excluir').on('click', function () {
                        var dados = $(this).data('id');
                        thiss.id = dados;

                        swall({
                            title: "Atenção!",
                            text: "Deseja realmente excluir o Convênio selecionado?",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonText: 'Sim',
                            cancelButtonText: "Não!"
                        })
                            .then(
                                function () {
                                    API.enviarRequisicao('delete', '/api/sist-obras/convenios/' + thiss.id)
                                        .then( resp => {
                                            swall('Atenção', 'O Convênio foi deletado com sucesso', 'success')
                                                .then(
                                                    function () {
                                                        history.go(0);
                                                    }
                                                )
                                        })
                                        .catch(error => {
                                            swall('Erro', 'O Convênio está sendo usado em Obras', 'error')
                                        });
                                },
                                function () {
                                    return false;
                                });
                    })
                }
            });


            function criarBotoes(id, ctrl) {
                if (ctrl != null) {
                    return '<a href="#" class="btnEditar' + ctrl + ' btn btn_editar_rh btn-default btn-sm">' +
                        '<i class="fa fa-edit" data-toggle="tooltip" title="Editar"></i>' +
                        '</a>' +
                        '<a href="#" data-id="' + id + '" class="btn btn-sm btn-info' + ctrl + ' btn btn-default btn-sm">' +
                        '<i class="fa fa-trash" data-toggle="tooltip" title="Deletar"></i>' +
                        '</a>';
                } else {
                    return "<button class='btn btn-sm editar' data-id='" + id + "'><i class='fa fa-edit text-info' ></i></button>" +
                        "<button class='btn btn-sm excluir' data-id='" + id + "'><i class='fa fa-trash text-danger'></i></button>";
                }
            }

            // axios
            //   .get('http://192.168.1.17:8085/api/sist-obras/convenios/dhtmlx')
            //   .then(response => {
            //     this.dados = response.data
            //     gridConv.parse(this.dados, "json");

            //     let thiss = this;
            //     let swall = this.$swal;
            //     $('.hdrcell').css('text-align', 'center');
            //     $('.editar').on('click', function(){
            //         var dados = $(this).data('id');
            //         thiss.id = dados;
            //         thiss.listagem = 'editar';
            //         thiss.paginaTop = 'EDITAR';
            //     })


            //     $('.excluir').on('click', function(){
            //       var dados = $(this).data('id');
            //       thiss.id = dados;

            //       swall({
            //         title: "Atenção!",
            //         text: "Deseja realmente excluir o Convênio selecionado?",
            //         type: "warning",
            //         showCancelButton: true,
            //         confirmButtonText: 'Sim',
            //         cancelButtonText: "Não!"
            //       })
            //       .then(
            //           function () {
            //             axios
            //             .delete("http://192.168.1.17:8085/api/sist-obras/convenios/"+thiss.id)
            //             .then(
            //                swall('Antenção', 'O Convênio foi deletado com sucesso', 'success')
            //                .then(
            //                   function () {
            //                     history.go(0);
            //                   }
            //                 )
            //             )
            //             .catch(error => {
            //               swall('Erro', 'O Convênio está sendo usado em Obras', 'error')

            //               });
            //           },
            //           function () {
            //             return false;
            //           });

            //     })
            //   })

            // gridConv = new dhtmlXGridObject('grid-convenios');
            // gridConv.setImagePath("libs/imgs/");
            // gridConv.setHeader("Código,Número,Objeto,'','','','','','',Fonte de Recurso,Ações");
            // gridConv.setInitWidths("70,150,450,0,100,100,100,100,100,250,95");
            // gridConv.setColAlign("left,left,left,left,left,left,left,left,center,center");
            // gridConv.setColTypes("ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro");
            // gridConv.setColSorting("na,int,str,str,str,str,str,str,str,str");
            // gridConv.attachEvent("onRowCreated",function(id){
            //     this.cells(id,10).setValue("<button class='btn btn-sm editar' data-id='"+id+"'><i class='fa fa-edit text-info'></i></button><button class='btn btn-sm excluir' data-id='"+id+"'><i class='fa fa-trash text-danger'></i></button>");
            //     return true;

            // });
            // gridConv.init();
            // gridConv.attachHeader("&nbsp;,#text_filter,#text_filter,&nbsp;,&nbsp;,&nbsp;,&nbsp;,&nbsp;,&nbsp;,#text_filter");
            // // gridConv.enableSmartRendering(true, 50);
            // gridConv.setColumnHidden(0,true);
            // gridConv.setColumnHidden(3,true);
            // gridConv.setColumnHidden(4,true);
            // gridConv.setColumnHidden(5,true);
            // gridConv.setColumnHidden(6,true);
            // gridConv.setColumnHidden(7,true);
            // gridConv.setColumnHidden(8,true);
        },
        methods: {
            viewAdicionar() {
                this.listagem = 'cadastro',
                    this.paginaTop = 'ADICIONAR DE CONVÊNIO',
                    $('#tabela').parents('div.dataTables_wrapper').first().hide();
            }

        }

    }

</script>

<style scoped>

    h2 {
        color: #5377C1;
    }

    a {
        background-color: #18A689;
        color: #fff;
        font-size: 12px;
        text-decoration: none;
    }

</style>
